import { useEffect } from 'react'

import TextInput from 'modules/core/components/Inputs/Text'
import i18n from 'modules/core/lib/i18n'

import { useFormProvider } from 'modules/processes/components/ItemWizard/Providers/form'
import { useValidationsProvider } from 'modules/processes/components/ItemWizard/Providers/validations'
import { useValidateStringLength } from 'modules/tasks/hooks/useValidateStringLength'

const Title = () => {
  const field = 'title'
  const { associatedTaskItem: item, form, setInitialFormValue } = useFormProvider()
  const { setFieldValidation, removeFieldValidation } = useValidationsProvider()

  const { validate, isValid } = useValidateStringLength()

  useEffect(() => {
    setInitialFormValue({ [field]: item?.title })
    validate(form.get(field).value)
  }, [])

  useEffect(() => {
    setFieldValidation({
      field,
      validation: () => isValid,
    })

    return () => {
      removeFieldValidation(field)
    }
  }, [isValid])

  return (
    <TextInput
      mandatory
      attachmentPosition="middle right"
      field={form.get(field)}
      validation={validate}
      label={i18n.t('processes.process_settings.wizard.title.label')}
      placeholder={i18n.t('processes.process_settings.wizard.title.placeholder')}
    />
  )
}

export default Title
